export default __webpack_public_path__ + "static/media/9.0231310b.jpg";